import { render, staticRenderFns } from "./chatHistory.vue?vue&type=template&id=3f46fb2b&scoped=true&"
import script from "./chatHistory.vue?vue&type=script&lang=js&"
export * from "./chatHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46fb2b",
  null
  
)

export default component.exports